var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 2.09205L1.7471 7.79416C0.779857 8.19948 0.785453 8.76244 1.56964 9.01347L5.2084 10.1978L13.6274 4.65579C14.0255 4.40309 14.3892 4.53903 14.0903 4.81592L7.26919 11.2386H7.26759L7.26919 11.2394L7.01818 15.1526C7.38589 15.1526 7.54817 14.9766 7.75441 14.769L9.52182 12.9758L13.1982 15.809C13.876 16.1984 14.3628 15.9983 14.5315 15.1543L16.9448 3.28802C17.1918 2.25468 16.5667 1.78681 15.92 2.09205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e604a24be40f1ca37820db9907de205d.svg";
export { ForwardRef as ReactComponent };